import React from 'react';
import { t } from '../../../../modules/infra/i18n';
import Queue from '../../../queue/QueueContainer';

const DownloadButton = () => (
  <Queue
    name="reports"
    btnLabel={t('register:cash_register.export_csv_button')}
    jobName="cash-register-report"
    label={t('register:cash_register.cash_register_report_label')}
  />
);

export default DownloadButton;
